import { useEffect } from 'react';
import { getBlogPostUrl } from '../utils/blogUtils';
import { resetPageMeta, setPageMeta } from '../utils/pageMeta';
import { getDefaultOgImageUrl, SITE_NAME } from '../config/siteBranding';

/** Set per-post title + Open Graph tags; reset on unmount */
export function useBlogPostMeta(post) {
  useEffect(() => {
    if (!post?.slug) return undefined;

    setPageMeta({
      title: `${post.title} | ${SITE_NAME}`,
      description: post.excerpt || post.title,
      // Prefer post cover; fall back to branded general sports share image
      image: post.coverImageUrl || getDefaultOgImageUrl(),
      url: getBlogPostUrl(post.slug),
    });

    return () => resetPageMeta();
  }, [post?.slug, post?.title, post?.excerpt, post?.coverImageUrl]);
}
